var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"lbLoadingPlaceholderItem\" ng-class=\"{ 'lbLoadingPlaceholderItem-heading': vm.isHeading }\" style=\"width: {{ ::item.width }};\" ng-repeat=\"item in ::vm.items\"></div>\n";
var id1="components/lbLoadingPlaceholder/lbLoadingPlaceholderItem.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbLoadingPlaceholder/lbLoadingPlaceholderItem.html
// module id = 1746
// module chunks = 5